
import { useEffect, useState } from "react";
import { JOBS_BY_JOBID } from "../../Utils/apis";

const useFetchJob = (jobId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [job, setJob] = useState({});

    useEffect(() => {
        if (!jobId) {
            setJob({});
            return;
        }

        const controller = new AbortController();

        const fetchJob = async () => {
            setLoading(true);
            setError("");

            try {
                const res = await fetch(
                    `${JOBS_BY_JOBID}?jobId=${encodeURIComponent(jobId)}`,
                    {
                        method: "GET",
                        credentials: "include",
                        signal: controller.signal,
                    }
                );

                const result = await res.json();

                if (!res.ok) {
                    throw new Error(
                        result?.message ||
                        result?.error ||
                        `Failed to fetch job (${res.status})`
                    );
                }

                setJob(result?.data ?? {});
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(err.message || "Failed to fetch job details");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchJob();

        return () => controller.abort();
    }, [jobId]);

    return [loading, error, job];
};

export default useFetchJob;
